import { Flex, Text } from "@fluentui/react-northstar";
import "./AttachmentButton.scss";

export const AttachmentButton = ({
  icon,
  content,
  isActive = false,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={`attachment-button ${isActive ? "active" : ""}`}
    >
      <Flex gap="gap.small" vAlign="center">
        {icon}
        <Text
          style={{ color: isActive ? "#fff" : "#6264a7", fontWeight: "600" }}
        >
          {content}
        </Text>
      </Flex>
    </div>
  );
};